import { render, staticRenderFns } from "./item_description.vue?vue&type=template&id=a84227fa&scoped=true&"
import script from "./item_description.vue?vue&type=script&lang=js&"
export * from "./item_description.vue?vue&type=script&lang=js&"
import style0 from "./item_description.vue?vue&type=style&index=0&id=a84227fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84227fa",
  null
  
)

export default component.exports